export const baseURL = process.env.NEXT_PUBLIC_API_URL;
export const recaptchaKey = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY;
export const recaptchaSecret = process.env.NEXT_PUBLIC_CAPTCHA_SITE_SECRET;
export const apiUrl = process.env.NODE_PUBLIC_API_URL;
export const twilioAccountSID = process.env.TWILIO_ACCOUNT_SID;
export const twilioAuthToken = process.env.TWILIO_AUTH_TOKEN;
export const twilioVerifySID = process.env.TWILIO_VERIFY_SERVICE_SID;
export const pricingTableId = process.env.NEXT_PUBLIC_PRICING_TABLE_ID;
export const publishableKey = process.env.NEXT_PUBLIC_PUBLISHABLE_KEY;
export const lite_production_paymentlink_monthly = 'https://buy.stripe.com/bIY28M6nL2M624w6ou';
export const lite_test_paymentlink_monthly = 'https://buy.stripe.com/test_dR67tU1MH0Ts1VK8wB';
export const lite_production_paymentlink_yearly = 'https://buy.stripe.com/00g8xadQdeuO10sbIP';
export const lite_test_paymentlink_yearly = 'https://buy.stripe.com/test_bIY5lMajd31AcAofZ6';
export const premium_production_paymentlink_monthly = 'https://buy.stripe.com/14kaFidQd9au9wYbIM';
export const premium_test_paymentlink_monthly = 'https://buy.stripe.com/test_aEU01s1MHcCa9oc7sy';
export const premium_production_paymentlink_yearly = 'https://buy.stripe.com/6oEbJmbI5biCcJaaEJ';
export const premium_test_paymentlink_yearly = 'https://buy.stripe.com/test_8wM9C2dvp31Abwk6ov';
export const strapiUrl = 'https://blogmanager.interworky.com';
